import React from 'react'
import styled from 'styled-components'
import cn from 'clsx'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'

import ResponsiveImage, { ImageParams } from '../../Common/ResponsiveImage'
import { StyledModalContent } from './ModalContent'

export const StyledModalImageThumbnail = styled.div`
  position: relative;
  width: 100%;

  & + ${StyledModalContent} {
    margin-top: ${rem(20)};

    ${mediaQueryUp.sm} {
      margin-top: ${rem(24)};
    }
  }
`

const FullWidthImg = styled.img`
  width: 100%;
`

export interface ModalImageThumbnailProps {
  // image: App.Image | App.Image[]
  className?: string
  image: App.Image
  imageParams?: ImageParams
}

/**
 * @description This component is the hero image within `ModalBody.tsx` which should always come immediately before `ModalContent.tsx`.
 * @see `Modal.tsx` for usage
 * */
function ModalImageThumbnail(props: ModalImageThumbnailProps) {
  const { className, image, imageParams } = props

  // TODO: if image is an array, use carousel
  // if (Array.isArray(image)) {
  //   return CAROUSEL
  // } else {
  //   return ONE IMAGE
  // }

  let imageElement = <ResponsiveImage
    {...imageParams}
    id={image.id ?? ''}
    alt={image.title}
  />

  if (!image.id) {
    imageElement = <FullWidthImg
      src={image.url}
      alt={image.title}
    />
  }

  return <StyledModalImageThumbnail className={cn('modal-image-thumbnail', className)}>
    {imageElement}
  </StyledModalImageThumbnail>
}

export default ModalImageThumbnail
